(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["restored-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  const initializeRestoredTestimonials = (section) => {
    if (section.dataset.sliderReady === 'true') return;

    const track = section.querySelector('[data-testimonial-track]');
    const dotsContainer = section.querySelector('[data-testimonial-dots]');
    const slides = Array.from(section.querySelectorAll('.restored-testimonials__slide'));

    if (!track || !dotsContainer || slides.length === 0) return;

    section.dataset.sliderReady = 'true';

    let pageIndex = 0;
    let itemsPerPage = window.matchMedia('(min-width: 750px)').matches ? 3 : 1;
    let timer;

    const pageCount = () => Math.ceil(slides.length / itemsPerPage);

    const showPage = (nextIndex) => {
      const totalPages = pageCount();
      pageIndex = (nextIndex + totalPages) % totalPages;
      track.style.transform = `translateX(-${pageIndex * 100}%)`;
      dotsContainer.querySelectorAll('button').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === pageIndex ? 'true' : 'false');
      });
    };

    const buildDots = () => {
      dotsContainer.replaceChildren();
      const label = section.dataset.label || '';

      for (let index = 0; index < pageCount(); index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'restored-testimonials__dot';
        dot.setAttribute('aria-label', `${label} ${index + 1}`);
        dot.addEventListener('click', () => showPage(index));
        dotsContainer.appendChild(dot);
      }

      showPage(0);
    };

    const stopAutoplay = () => {
      window.clearInterval(timer);
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (pageCount() < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => showPage(pageIndex + 1), 6000);
    };

    const rebuild = () => {
      const nextItemsPerPage = window.matchMedia('(min-width: 750px)').matches ? 3 : 1;
      if (nextItemsPerPage === itemsPerPage && dotsContainer.children.length > 0) return;
      itemsPerPage = nextItemsPerPage;
      buildDots();
      startAutoplay();
    };

    buildDots();
    startAutoplay();
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);
    window.addEventListener('resize', rebuild);
  };

  const initializeAllRestoredTestimonials = (root = document) => {
    root.querySelectorAll('[data-restored-testimonials]').forEach(initializeRestoredTestimonials);
  };

  initializeAllRestoredTestimonials();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllRestoredTestimonials(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
